import {Navigate, Outlet, useLocation} from 'react-router';
import {useAtomValue} from 'jotai';
import {cachedSessionAtom} from '@/state/authAtoms';
import {RoleType} from '@/types/types.ts';
import {routerLinks} from '@/Constants.ts';

/**
 * Allows Admin or Super Admin user to the outlet. Others are redirected to '/wells'.
 */
export function AdminAuth() {
   const cachedSession = useAtomValue(cachedSessionAtom);
   const location = useLocation();

   if (cachedSession?.role !== RoleType.Admin && cachedSession?.role !== RoleType.SuperAdmin) {
      return <Navigate to={routerLinks.wells} state={{from: location}} replace />;
   }

   return <Outlet />;
}
